import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig, ENV_CONFIG } from '@emi/shared/models';
import { selectAuthState } from 'libs/shared/state/auth/src/lib/auth.selectors';
import { AuthState } from 'libs/shared/state/auth/src/lib/auth.reducer';


@Injectable({
    providedIn: 'root',
})
export class HttpService {
    public apiBaseUrl: string;

    private headers: HttpHeaders;

    constructor(@Inject(ENV_CONFIG) private config: EnvironmentConfig, protected http: HttpClient, public authStore: Store<AuthState>) {
        this.apiBaseUrl = `${this.config.apiBaseUrl}`;

        this.authStore.pipe(select(selectAuthState)).subscribe((state) => {
            this.headers = new HttpHeaders()
                .set('Authorization', 'Bearer ' + state.accessToken)
                .set('x-subscriber-id', state.subscription.pkId);
        });
    }

    public getHttp<T>(route: string, queryParams?: object, httpHeaders?: HttpHeader[], baseUrl: string = this.apiBaseUrl): Observable<T> {
        if (httpHeaders && httpHeaders.length > 0) {
            httpHeaders.forEach((header) => (this.headers = this.headers.set(header.name, header.value)));
        }

        return this.http.get<T>(baseUrl + route + this.getQueryParams(queryParams), { headers: this.headers });
    }

    public getHttpText(
        route: string,
        queryParams?: object,
        httpHeaders?: HttpHeader[],
        baseUrl: string = this.apiBaseUrl
    ): Observable<string> {
        if (httpHeaders && httpHeaders.length > 0) {
            httpHeaders.forEach((header) => (this.headers = this.headers.set(header.name, header.value)));
        }
        return this.http.get(baseUrl + route + this.getQueryParams(queryParams), {
            responseType: 'text',
            headers: this.headers,
        });
    }

    public postHttp<T>(route: string, data: object = {}, baseUrl: string = this.apiBaseUrl): Observable<T> {
        return this.http.post<T>(baseUrl + route, data, { headers: this.headers });
    }

    public deleteHttp(route: string, id: number) {
        return this.http.delete(this.apiBaseUrl + route + '/' + id, { headers: this.headers });
    }

    public downloadHttp(route: string) {
        return this.http.get(this.apiBaseUrl + route, { headers: this.headers, responseType: 'blob' });
    }

    private getQueryParams(queryParamsDictionary: any): string {
        if (!queryParamsDictionary) {
            return '';
        }

        const objKeys = Object.keys(queryParamsDictionary);
        if (!objKeys || objKeys.length === 0) {
            return '';
        }

        let paramString = '?';
        objKeys.forEach((key, i) => {
            paramString += `${key}=${queryParamsDictionary[key]}`;
            if (i !== objKeys.length - 1) {
                paramString += '&';
            }
        });
        return paramString;
    }
}

export interface HttpHeader {
    name: string;
    value: string;
}
